import { PageHeader, Styles } from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function FairsMenu({ title }) {
  usePageTitle({ title })

  const { pathname } = useLocation()

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatórios por feiras de adoção"
        subtitle="Selecione o relatório que deseja visualizar"
        icon="fas fa-dog"
      />
      <table className="table">
        <thead>
          <tr>
            <th>Relatório</th>
            <th width="1" className="text-right">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fas fa-fw fa-heart" />
              Resumo das feiras de adoção
              <small>
                &nbsp; (Consulta de animais e adoções nas feiras do município e
                online)
              </small>
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/animals-in-fair`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 fab fa-fw fa-gratipay" />
              Adoções mensais por feira
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/monthly-adoptions-by-fair`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <i className="s-rounded p-1 mr-2 far fa-fw fa-heart" />
              Adoções realizadas nas feiras
            </td>
            <td className="text-right">
              <Link
                to={`${pathname}/adoptions-in-fairs`}
                className="btn btn-action btn-sm btn-primary"
              >
                <i className="fas fa-eye" />
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles.Container>
  )
}

export default FairsMenu
